<style scoped>
.quiz-options-wrapper {
  padding: 10px;
}
.quiz-import {
  margin: 15px 0;
}
.quiz-list-body {
  padding: 10px;
}
.add-question-content {
  padding: 10px;
}
.add-question-item {
  padding: 20px;
}
.margin-right {
  margin-right: 10px;
}
</style>

<template>
  <div>
    <mu-button small icon @click="onClickBack"><mu-icon value="keyboard_backspace" /></mu-button>
    <div class="display-flex full-width">
      <div class="quiz-options-wrapper">
        <div class="item-title">
          {{$t('button.manage') + $t('space') + $t('question.title')}}
        </div>
        <mu-form :model="question">
          <mu-form-item prop="input" :label="$t('question.mcAnswersNum')">
            <mu-text-field type="number" v-model="modelMcAnswersNum" @change="onActionEditChannel" min="1"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="input" :label="$t('question.trial_edit')">
            <mu-text-field type="number" v-model="modelTrial" @change="onActionEdit" min="1"></mu-text-field>
          </mu-form-item>
          <mu-checkbox v-if="media.type == 'video' || media.type == 'youtube' || media.type == 'mp4link'" v-model="modelQuizEndShow" :label="$t('question.quizEndShow')" class="margin-right" @change="onActionEdit"></mu-checkbox>
          <p>
            <label>{{$t('question.deadline')}}</label>
            <br />
            <date-picker
              v-model="modelDeadline"
              type="datetime"
              lang="en"
              format="YYYY-MM-DD HH:mm:ss"
              @change="onActionEdit"
              @clear="onClearDeadline"
              />
          </p>
          <p>
            <label>{{$t('question.answerRelease')}}</label>
            <br />
            <date-picker
              v-model="modelAnswerRelease"
              type="datetime"
              lang="en"
              format="YYYY-MM-DD HH:mm:ss"
              @change="onActionEdit"
              @clear="onClearAnswerRelease"
              />
          </p>
        </mu-form>
        <mu-button class="quiz-import" @click="flagDialogClone = true" color="primary">{{$t('question.import')}}</mu-button>
      </div>
      <div class="flex-item quiz-list-body">
        <div class="text-align-right">
          <mu-checkbox v-model="modelQuestionTypeAll" :label="$t('prompt.all')" class="margin-right" ></mu-checkbox>
          <mu-checkbox v-model="modelQuestionType" value="mc" :label="$t('question.mc')" class="margin-right" ></mu-checkbox>
          <mu-checkbox v-model="modelQuestionType" value="open" :label="$t('question.open')" class="margin-right" ></mu-checkbox>
          <mu-checkbox v-model="modelQuestionType" value="file" :label="$t('question.file')" class="margin-right" ></mu-checkbox>
          <mu-checkbox v-model="modelQuestionType" value="turnitin" :label="$t('question.turnitin')" class="margin-right" ></mu-checkbox>
        </div>
        <transition name="slide-fade" mode="out-in">
          <div v-if="flagFetchedQuestion && flagFetchedMedia && !sorting">
            <draggable :list="questions" v-if="questions.length" @change="onChangeOrder" :options="{handle:'.drag-handle'}">
              <transition-group tag="div" name="list-complete" v-if="questions.length">
                <question-item
                  v-for="(question, index) in questions"
                  :key="index"
                  :question="question"
                  :media="media"
                  v-if="isShow(question)"/>
              </transition-group>
            </draggable>
          </div>
        </transition>
        <div class="add-question-content">
          <mu-paper :z-depth="1" class="add-question-item">
            <mu-flex justify-content="center">
              <mu-button flat color="primary" @click="onClickCreateQuestion">
                <mu-icon value="add" />{{$t('button.add') + $t('space') + $t('question.question')}}
              </mu-button>
            </mu-flex>
          </mu-paper>
        </div>
      </div>
    </div>
    <mu-dialog :title="$t('button.add') + $t('space') + $t('question.question')" max-width="100%" scrollable :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogCreate">
      <mu-form :model="question">
        <mu-row gutter>
          <mu-col :span="modelType == 'mc' ? 6 : 12">
            <mu-form-item prop="input" :label="$t('question.title')">
              <mu-text-field v-model="modelContent" multi-line :rows="3" full-width></mu-text-field>
            </mu-form-item>
            <mu-form-item prop="input" :label="$t('question.prompt')">
              <mu-text-field v-model="modelPrompt" multi-line :rows="3" full-width></mu-text-field>
            </mu-form-item>
            <mu-form-item prop="radio">
              <mu-radio v-model="modelType" value="mc" :label="$t('question.mc')"></mu-radio>
              <mu-radio v-model="modelType" value="open" :label="$t('question.open')"></mu-radio>
              <mu-radio v-model="modelType" value="file" :label="$t('question.file')"></mu-radio>
              <mu-radio v-model="modelType" value="turnitin" :label="$t('question.turnitin')"></mu-radio>
            </mu-form-item>
            <div v-if="modelType == 'mc'">
              <mu-form-item prop="checkbox">
                <mu-checkbox v-model="modelMultiSelect" :label="$t('question.multiSelect')"></mu-checkbox>
                <mu-checkbox v-model="modelRandOrder" :label="$t('question.randOrder')"></mu-checkbox>
              </mu-form-item>
            </div>
            <!---
            <div v-if="modelType != 'turnitin' && modelType != 'file'">
              <mu-form-item prop="radio">
                <mu-radio v-model="modelAnonymous" :value="constTrue" :label="$t('question.anonymousTrue')"></mu-radio>
                <mu-radio v-model="modelAnonymous" :value="constFalse" :label="$t('question.anonymousFalse')"></mu-radio>
              </mu-form-item>
            </div>
            !--->
          </mu-col>
          <mu-col span="6" v-if="modelType == 'mc'">
            <div class="text-align-right">
              <mu-button color="primary" @click="onClickAddAnswer">
                <mu-icon left value="add"></mu-icon> {{$t('button.add') + $t('space') + $t('answer.title')}}
              </mu-button>
            </div>
            <draggable :list="modelAnswers" v-if="modelAnswers.length" :options="{handle:'.drag-handle'}">
              <div v-for="(ans, index) in modelAnswers" class="full-width display-flex" :key="index">
                <mu-form-item prop="input" :label="$t('answer.title') + ' ' + (index + 1)" class="flex-item">
                  <mu-text-field v-model="modelAnswers[index]">
                    <mu-icon value="swap_vert" class="drag-handle" slot="prepend"></mu-icon>
                    <mu-checkbox :value="index" slot="prepend" v-model="modelCorrectAnswers" v-if="modelMultiSelect"/>
                    <mu-radio :value="index" slot="prepend" v-model="modelCorrectAnswer" v-else />
                    <mu-button icon @click="onClickRemoveAnswer(index)" slot="append">
                      <mu-icon value="delete"></mu-icon>
                    </mu-button>
                  </mu-text-field>
                  <mu-text-field v-model="modelFeedback[index]" :placeholder="$t('answer.feedback')"/>
                </mu-form-item>
              </div>
            </draggable>
          </mu-col>
        </mu-row>
      </mu-form>
      <mu-button slot="actions" flat color="primary" @click="onActionCancel"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
      <mu-button slot="actions" flat color="primary" @click="onCreateQuestion" :disabled="isContentEmpty"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
    </mu-dialog>
    
    <mu-dialog :title="$t('button.import') + $t('space') + $t('question.title')" max-width="100%" scrollable :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogClone">
      {{$t('question.import_description')}}
      <mu-data-table selectable select-all :selects.sync="modelMedia" checkbox :columns="columnsMedia" :data="computedMedias" max-height="100%">
          <template slot-scope="scope">
            <td>{{scope.row.name}}</td>
            <td>{{ $t('media.' + scope.row.type) }}</td>
          </template>
        </mu-data-table>
      <mu-button slot="actions" flat color="primary" @click="flagDialogClone = false"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
      <mu-button slot="actions" flat color="primary" @click="onActionClone" :disabled="isMediaEmpty"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
// Components
import QuestionItem from '@/components/Quiz/QuestionItem.vue'

// Library
import axios from "axios";
import draggable from 'vuedraggable'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'QuestionPage',
  components: {
    QuestionItem,
    draggable,
    DatePicker
  },
  props: {
    mediaId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      sorting: false,

      // Object
      questions: [],
      media: {}, // Media object
      question: {},
      medias: [],

      // Flag
      flagFetchedMedia: false, // Boolean variable for status of media fetched
      flagFetchedQuestion: false, // Boolean variable for status of question fetched
      flagDialogCreate: false, // Boolean variable for status of create dialog
      flagDialogClone: false, // Boolean variable for status of clone dialog

      //Model
      modelContent: "", // Bind with content input
      modelPrompt: "",
      modelType: "mc", // Bind with type input
      modelMultiSelect: false, // Bind with multi_select input
      modelRandOrder: false, // Bind with rand_order input
      modelAnonymous: false, // Bind with anonymous input
      modelQuestionType: ['mc', 'open', 'file', 'turnitin'],
      modelQuizEndShow: false,
      modelTrial: 1,
      modelMcAnswersNum: 4,
      modelDeadline: "",
      modelAnswerRelease: "",
      modelAnswers: ["", "", "", ""],
      modelFeedback: ["", "", "", ""],
      modelMedia: [],
      modelCorrectAnswers: [],
      modelCorrectAnswer: 0,
    }
  },
  computed: {
    // Flag
    isContentEmpty() {
      if (this.modelContent === "") {
        return true;
      } else {
        return false;
      }
    },
    isMediaEmpty() {
      if (this.modelMedia.length === 0) {
        return true;
      } else {
        return false;
      }
    },

    // Constant
    constTrue() {
      return true;
    },
    constFalse() {
      return false;
    },

    // Model
    modelQuestionTypeAll: {
      get() {
        if(this.modelQuestionType.length >= 2)
        return true;
        else
        return false;
      },
      set(newValue) {
        if(newValue)
          this.modelQuestionType = ['mc', 'open', 'file', 'turnitin'];
        else
          this.modelQuestionType = [];
      }
    },

    // Store
    triggerRefresh() {
      return this.$store.getters.triggerRefresh;
    },
    
    // Columns
    columnsMedia() {
      return [
        { title: this.$t('media.title'), name: 'name', sortable: true },
        { title: this.$t('media.type'), name: 'type', sortable: true },
      ];
    },
    
    // Computed Model
    computedMedias() {
      return this.medias.filter(item => this.mediaId !== item._id);
    },
    computedModelMedia() {
      var array = [];
      this.modelMedia.forEach(item => {
        array.push(this.computedMedias[item]._id);
      });
      return array;
    },
  },
  watch: {
    triggerRefresh() {
      this.fetchMedia();
      this.flagFetchedQuestion = false;
      this.fetchQuestions();
    },
    modelMcAnswersNum(newValue) {
      this.modelAnswers = [];
      this.modelFeedback = [];
      var i;
      for (i = 0; i < newValue; i++) { 
        this.modelAnswers.push("");
        this.modelFeedback.push("");
      }
    },
  },
  created() {

    this.checkPermit();
  },
  methods: {
    // Fetch
    checkPermit() {
      axios.get(this.$store.getters.urlApi + "permit/media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        var result = response.data.data.admin;
        if(result) {
          this.fetchMedia();
        } else {

          this.$router.push({
            name: 'Home'
          });
        }
      });
    },
    fetchMedia() {
      axios.get(this.$store.getters.urlApi + "media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.media = response.data.data.media;
        this.modelTrial = this.media.trial;
        this.modelAnswerRelease = this.media.answer_release;
        this.modelDeadline = this.media.deadline;
        this.modelQuizEndShow = this.media.quiz_end_show;
        this.flagFetchedMedia = true;
        this.fetchAdmin();
        this.fetchQuestions();
        this.fetchMedias();
        this.fetchChannel();
      });
    },
    fetchChannel() {
      axios.get(this.$store.getters.urlApi + "channel/" + this.media.channel_id, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        if(response.data.data.mcAnswerNum) {
          this.modelMcAnswersNum = response.data.data.mcAnswerNum;
          this.modelAnswers = [];
          var i;
          for (i = 0; i < modelMcAnswersNum; i++) { 
            this.modelAnswers.push("");
          }
        }
      });
    },
    fetchQuestions() {
      axios.get(this.$store.getters.urlApi + "question/media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        if(response.data.data.questions)
          this.questions = response.data.data.questions;
        this.flagFetchedQuestion = true;

      });
    },
    fetchAdmin() {
      axios.get(this.$store.getters.urlApi + "admin/channel/" + this.media.channel_id, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        var result = response.data.data.admin.user_ids.includes(this.$store.state.auth.user._id) || this.$store.getters.isAdmin;
        if(!result) {
          this.$router.back();
        }
      });
    },
    fetchMedias() {
      axios.get(this.$store.getters.urlApi + "media/channel/" + this.media.channel_id, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.medias = response.data.data.medias;
      });
    },

    // Event
    onClickCreateQuestion() {
      this.flagDialogCreate = true;
      this.modelContent = "";
      this.modelType = "mc";
    },
    onCreateQuestion() {
      this.flagDialogCreate = false;
      var body;
      var data = {
        'content': this.modelContent,
        'prompt': this.modelPrompt,
        'type': this.modelType,
        'multi_select': this.modelMultiSelect,
        'rand_order': this.modelRandOrder,
        'anonymous': this.modelAnonymous,
        'answers': this.modelAnswers,
        'feedback': this.modelFeedback
      };
      if(this.modelType === 'mc') {
        if(this.modelMultiSelect) {
          data['correct'] = this.modelCorrectAnswers;
        } else {
          data['correct'] = [this.modelCorrectAnswer];
        }
        body = JSON.stringify(data);
      } else {
        body = JSON.stringify({
          'content': this.modelContent,
          'prompt': this.modelPrompt,
          'type': this.modelType,
          'multi_select': this.modelMultiSelect,
          'rand_order': this.modelRandOrder,
          'anonymous': this.modelAnonymous
        });
      }
      axios.post(this.$store.getters.urlApi + "question/media/" + this.mediaId, body, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(() => {
        this.fetchMedia();
        this.modelType = "mc";
        this.modelAnswers = [];
        this.modelFeedback = [];
        var i;
        for (i = 0; i < this.modelMcAnswersNum; i++) { 
          this.modelAnswers.push("");
          this.modelFeedback.push("");
        }
        this.$toast.success(this.$t('toast.create'));
      });
    },
    onActionCancel() {
      this.flagDialogCreate = false;
      this.modelType = "mc";
      this.modelAnswers = [];
      this.modelFeedback = [];
      var i;
      for (i = 0; i < this.modelMcAnswersNum; i++) { 
        this.modelAnswers.push("");
        this.modelFeedback.push("");
      }
    },
    onChangeOrder() {
      axios.put(this.$store.getters.urlApi + "question", {
        'data': this.questions
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(() => {
        this.$store.commit("triggerRefresh");
      });
    },
    onClickAddAnswer() {
      this.modelAnswers.push("");
    },
    onClickRemoveAnswer(index) {
      this.modelAnswers.splice(index, 1);
    },
    onActionEdit() {
      axios.put(this.$store.getters.urlApi + "media/" + this.mediaId, {
        'trial': parseInt(this.modelTrial),
        'answer_release': this.modelAnswerRelease,
        'deadline': this.modelDeadline,
        'quiz_end_show': this.modelQuizEndShow
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      );
    },
    onActionEditChannel() {
      axios.put(this.$store.getters.urlApi + "channel/" + this.media.channel_id, {
        'mcAnswersNum': parseInt(this.modelMcAnswersNum)
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      );
    },
    onClickBack() {
      if(this.$route.params.fromChannel) {
        if(typeof this.$route.params.playlistId !== 'undefined') {
          this.$router.push({
            name: 'ChannelPlaylist',
            params: {
              channelId: this.media.channel_id,
              playlistId: this.$route.params.playlistId
            }
          });
        } else {
          this.$router.push({
            name: 'Channel',
            params: {
              channelId: this.media.channel_id
            }
          });
        }
      } else {
        if(typeof this.$route.params.playlistId !== 'undefined') {
          this.$router.push({
            name: 'PlaylistMedia',
            params: {
              mediaId: this.mediaId,
              playlistId: this.$route.params.playlistId
            }
          });
        } else {
          this.$router.push({
            name: 'Media',
            params: {
              mediaId: this.mediaId
            }
          });
        }
      }
    },
    onActionClone() {
      this.flagDialogClone = false;
      axios.post(this.$store.getters.urlApi + "question/media/" + this.mediaId + '/clone', {
        'media': this.computedModelMedia
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(() => {
        this.$store.commit("triggerRefresh");
        this.$toast.success(this.$t('toast.clone'));
      });
    },
    onClearDeadline() {
      this.modelDeadline = "";
      this.onActionEdit();
    },
    onClearAnswerRelease() {
      this.modelAnswerRelease = "";
      this.onActionEdit();
    },

    // Flag
    isShow(question) {
      var type = question.type;
      if(this.modelQuestionType.includes(type))
        return true;
      else
        return false;
    },
  },
}
</script>
